import { defineMessages } from 'react-intl-next';

export default defineMessages({
	noOptionsMessage: {
		id: 'eoc.alert-list.common.generic-select.no-options-message.no-options-message',
		defaultMessage: 'We couldn’t match with what you’ve typed. Check the spelling.',
		description: 'The text for when no matches are found in dropdown',
	},
	noOptionsWithNoValueMessage: {
		id: 'eoc.alert-list.common.generic-select.no-options-message-with-no-value-message.no-options-message',
		defaultMessage: 'Start typing to search.',
		description: 'The text for when no matches are found in dropdown',
	},
});
